import { useGame } from "@/game/GameContext";
import SoundToggle from "@/components/SoundToggle";
import StartScreen from "@/screens/StartScreen";
import HowToPlayScreen from "@/screens/HowToPlayScreen";
import CharacterSelectScreen from "@/screens/CharacterSelectScreen";
import BusinessSetupScreen from "@/screens/BusinessSetupScreen";
import BudgetWheelScreen from "@/screens/BudgetWheelScreen";
import SuppliesScreen from "@/screens/SuppliesScreen";
import MonthScreen from "@/screens/MonthScreen";
import EndScreen from "@/screens/EndScreen";

export default function GameRoot() {
  const { state } = useGame();
  const screen = state.screen;
  return (
    <div className="relative min-h-screen">
      <SoundToggle />
      {screen === "start" && <StartScreen />}
      {screen === "how" && <HowToPlayScreen />}
      {screen === "character" && <CharacterSelectScreen />}
      {screen === "business" && <BusinessSetupScreen />}
      {screen === "wheel" && <BudgetWheelScreen />}
      {screen === "supplies" && <SuppliesScreen />}
      {screen === "month" && <MonthScreen />}
      {screen === "end" && <EndScreen />}
    </div>
  );
}
